// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"4ae7f811","767":"3b7d530d"}[chunkId] + ".chunk.js";
};